/**
 * Dependency-free home of the current build hash so low-level modules (AppInsights) can read it
 * without importing buildVersion.ts, which depends on the logger (and thus on AppInsights).
 */
export const DEV_BUILD_HASH = 'dev';

export const CURRENT_BUILD_HASH: string = import.meta.env.VITE_BUILD_HASH ?? DEV_BUILD_HASH;
